"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var tombacIcon_1 = require("../tombacIcon");
function SvgClosure(props) {
    return (React.createElement("svg", tslib_1.__assign({ viewBox: "4 -4 16 24" }, props),
        React.createElement("path", { d: "M12 0a8 8 0 110 16 8 8 0 010-16zM7 7v2h10V7z", fill: "currentColor" })));
}
exports.default = tombacIcon_1.default('Closure')(SvgClosure);
//# sourceMappingURL=Closure.js.map